import { Box, Typography } from '@mui/material'
import { classNames, formatDate, formatStringDate } from '../../utils/Utils'
import { useTranslation } from 'react-i18next'
import LaunchRoundedIcon from '@mui/icons-material/LaunchRounded'
import { useColorModeContext } from '../../context/ColorModeContext'

interface Props {
  data: {
    path: string
    errors?: number
    warnings?: number
  },
  options
}
const SitemapErrors = ({ data, options }: Props) => {
  const { t } = useTranslation()
  const { mode } = useColorModeContext();

  const showIconRedirect = (url:string) => {

    const id = options.model.project
    const link = `https://search.google.com/search-console/${url}?resource_id=${id}&pages=SITEMAP&sitemap=${data.path}`

    return (
      <a target="_blank" href={link} rel="noopener noreferrer"
         className={classNames('btn-link keywordLinkBlank', mode)}>
        <div>
          <LaunchRoundedIcon className="noColor" fontSize="small" />
        </div>
      </a>
    )
  }

  return (
    <>
      {data.errors ?
        <Box display='flex' alignItems='flex-end' >
          <Typography sx={{ color: 'red' }} >{`${data.errors} ${t('errors')}`}</Typography>
          {showIconRedirect('sitemaps/info-drilldown')}
        </Box>
        : null
      }

      {data.warnings ?
        <Box display='flex' alignItems='flex-end' >
          <Typography sx={{ color: 'orange' }} >{`${data.warnings} ${t('warnings')}`} </Typography>
          {showIconRedirect('index')}
        </Box>
        : null
      }
    </>
  )
}

export default SitemapErrors;